import { Link } from 'react-router-dom';

import { track } from '../lib/analytics';

import { BrandMark } from './BrandMark';

export const Footer = () => (
  <footer className="footer">
    <div className="container footer__inner">
      <div className="footer__brand">
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 'var(--space-2)',
          }}
        >
          <BrandMark />
          <span className="brand__name" style={{ color: 'var(--paper)' }}>
            Prepzio
          </span>
        </div>
        <p className="footer__tag">
          A pocket-sized practice coach that teaches AI-using juniors how to actually think.
        </p>
      </div>

      <div className="footer__col">
        <h4>Product</h4>
        <ul>
          <li>
            <Link to="/blog">Blog</Link>
          </li>
          <li>
            <a href="/#problem">Why Prepzio</a>
          </li>
          <li>
            <a href="/#how">How it works</a>
          </li>
          <li>
            <a href="/#faq">FAQ</a>
          </li>
        </ul>
      </div>

      <div className="footer__col">
        <h4>Legal</h4>
        <ul>
          <li>
            <Link to="/privacy" onClick={() => track('privacy_link_click')}>
              Privacy
            </Link>
          </li>
          <li>
            <Link to="/terms">Terms</Link>
          </li>
          <li>
            <a href="mailto:hello@prepzio.io">Contact</a>
          </li>
        </ul>
      </div>
    </div>

    <div className="container footer__bottom">
      <span>© {new Date().getFullYear()} Prepzio</span>
      <span>Built for self-taught & bootcamp juniors</span>
    </div>
  </footer>
);
